module.exports = __webpack_public_path__ + "img/icon-qr.7bb280f2.svg";